import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { WaitingListApplicantsListComponent } from './waiting-list-applicants-list/waiting-list-applicants-list.component';

@NgModule({
  declarations: [
    WaitingListApplicantsListComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class WaitingListApplicantsModule { }